<ng-container *ngIf="!saving; else savingTemplate">
  <sb-icon [name]="statusMapping[status].icon"></sb-icon>
  <span class="sr-only">{{ statusMapping[status].label | translate }}</span>
</ng-container>
<ng-template #savingTemplate>
  <sb-spinner [size]="'sm'" [strokeColor]="'current'"></sb-spinner>
</ng-template>
